import { PureQueryOptions, RefetchQueriesFunction } from '@apollo/client';
import { CommodityMilestone } from '@bechtel/types';
export interface RejectMilestoneProps {
  milestone: CommodityMilestone;
  onClose: () => void;
  refetchQueries?: (string | PureQueryOptions)[] | RefetchQueriesFunction;
  onActionCompleted?: () => void;
}
